import { apiClient, createSuccessResponse, handleApiError } from "./api";


const panelService = {

    async list(page = 1, pageSize = 10, filters = {}, sortBy = null, sortOrder = null) {
        try {
            const params = new URLSearchParams({
                page: page.toString(),
                pageSize: pageSize.toString(),
                ...filters
            });

            // Adicionar parâmetros de ordenação se fornecidos
            if (sortBy) {
                params.append('sortBy', sortBy);
            }
            if (sortOrder) {
                params.append('sortOrder', sortOrder);
            }

            const retorno = await apiClient.get(`/panel?${params.toString()}`);

            return {
                data: retorno.data.data,
                pagination: retorno.data.pagination,
            };
        } catch (error) {
            const processedError = handleApiError(error);
            console.error("❌ [panelService] Erro ao listar painéis:", processedError);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },

    async listActive(page = 1, pageSize = 10) {
        try {
            var retorno = await apiClient.get(`/panel/active?page=${page}&pageSize=${pageSize}`);

            return {
                data: retorno.data.data,
                pagination: retorno.data.pagination,
            };
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },

    async edit(id) {
        try {
            var retorno = await apiClient.get("/panel/" + id);
            return createSuccessResponse(retorno.data, retorno.status, retorno.message);
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },

    async listInsertsByQtd(qtd) {
        try {
            var retorno = await apiClient.get("/qtdinsert/" + qtd);
            return retorno.data;
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },

    async listPanelFilter(name) {
        try {
            var retorno = await apiClient.get('/panel/filter/' + name);

            return retorno.data;
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },

    async save(panel) {
        try {
            var retorno = await apiClient.post("/panel", panel, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            return createSuccessResponse(retorno.data, retorno.status, retorno.message);
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },

    async update(panel) {
        try {
            // var retorno = await apiClient.put("/panel", panel);

            var retorno = await apiClient.put('/panel', panel, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            return createSuccessResponse(retorno.data, retorno.status, retorno.message);
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },

    async delete(idcustomer) {
        try {
            var retorno = await apiClient.delete("/panel/" + idcustomer);

            return createSuccessResponse(retorno.data, retorno.status, retorno.message);
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },

    async getFormat(id) {
        try {
            var retorno = await apiClient.get("/format-panel/" + id);
            return retorno.data;
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },

    async listFormat() {
        try {
            var retorno = await apiClient.get("/format-panel");
            return retorno.data;
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },


}

export default panelService;